import Payments from "./components/Payments";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentFailure from "./components/PaymentFailure";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';

function App() {
   return (
    <Router>
      <Routes>
        <Route path="/" element={<Payments />} />
        <Route path="/stripepayment" element={<Payments />} />
        <Route path="/stripepayment/success/:txnId" element={<PaymentSuccess />} />
        <Route path="/stripepayment/failure/:txnId" element={<PaymentFailure />} />
      </Routes>
    </Router>
  );
}

export default App;
